<template>
  <el-dialog
    :title="'【' + modelParam.task_id + '】' + modelParam.describe"
    center
    class="devOps-modelTen"
    :visible.sync="dialogVisible"
    width="80%"
    top="10px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="安全验证描述" prop="security_content">
        <Editor
          :content="form.security_content"
          @contentData="changeEditContent"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="安全验证地址" prop="security_url">
        <el-input placeholder="请输入" v-model="form.security_url"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :disabled="runLoading"
          type="warning"
          @click="onSubmit('run')"
          >提交<i v-show="runLoading" class="el-icon-loading"></i
        ></el-button>
        <el-button
          :disabled="skipLoading"
          type="warning"
          @click="onSubmit('skip')"
          >跳过<i v-show="skipLoading" class="el-icon-loading"></i
        ></el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi"
          >查看历史</el-button
        >
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
} from "@/server/tops/devOps";
import { Editor } from "@/components/index.js";

import { TableOne } from "../table/index";

export default {
  components: { TableOne, Editor },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () {};
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        security_content: ''
      },
      rules: {
        security_content: [
          { required: true, message: "请输入安全验证描述", trigger: "blur" },
        ],
      },
      message: "",
      runLoading: false,
      skipLoading: false,
      tableData: [],
    };
  },
  async mounted() {
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  methods: {
    changeEditContent(val) {
      this.form.security_content = val;
    },
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = { ...this.form, ...ret.data };
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);

        this.$notify({
          message: ret.status === "success" ? "跳过成功" : "跳过失败",
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
        this.tableData = [];
      }
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;

          const { security_content = "", security_url = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            security_content,
            security_url,
          };
          this.runLoading = true;
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            this.message = JSON.stringify(ret.data || "", null, 2);
            let info = ret?.data?.output?.security[0] || {};
            this.$notify({
              message: info.msg || "",
              type: info.code === 0 ? "success" : "error",
            });
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelTen {
  .el-input__inner {
    font-size: 14px!important;
  }
  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }
  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }
  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;
    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>